import {
  Dispatch,
  FC,
  ReactElement,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react'

interface ContextInterface {
  footer: ReactElement
  setFooter: Dispatch<SetStateAction<ReactElement>>
  isEmpty: boolean
  setIsEmpty: Dispatch<SetStateAction<boolean>>
}

const TableContext = createContext<Partial<ContextInterface>>(
  {} as ContextInterface,
)

interface ProviderProps {
  children: ReactElement
}

const TableProvider: FC<ProviderProps> = ({ children }) => {
  const [footer, setFooter] = useState<ReactElement>(null)
  const [isEmpty, setIsEmpty] = useState<boolean>(true)
  return (
    <TableContext.Provider
      value={{
        footer,
        setFooter,
        isEmpty,
        setIsEmpty,
      }}>
      {children}
    </TableContext.Provider>
  )
}

const useTable = () => useContext(TableContext)
const TableConsumer = TableContext.Consumer
export { useTable, TableProvider, TableContext, TableConsumer }
